import http from './http'

class Activities {
  get (id) {
    return http.get(`/activities/balance/${id}`)
  }

  create (activity) {
    return http.post('/activities', { activity })
  }
}

export default new Activities()



// WEBPACK FOOTER //
// ./src/services/activities.js